module.exports = __webpack_public_path__ + "img/logo.c386bfd2.png";